import { get } from '../../Services/NetteApiClient';
import UserAvatar from '../UserAvatar/UserAvatar';

export default function SearchWorkplaceResult(props) {
	const {
		workplace,
		handleClick,
		showArrow = true,
		showRemove = false,
	} = props;

	// @ts-ignore
	const onClick = async workplace => {
		handleClick(workplace);
	};

	return (
		<a
			onClick={() => onClick(workplace)}
			className='search-user-result__item d-flex'>
			<div className='search-user-result__item__name'>{workplace.name}</div>
		</a>
	);
}
